module.exports = __webpack_public_path__ + "img/no-check.9236630a.svg";